import type { PendingReviewLineItemVO } from "@/store/vendorApi";
import type { OverlayMenuType, SetOpenMenuPayload } from "@/types/overlayMenu";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface VendorOrderItemsMenuPayload {
  vendorName: string;
  items: PendingReviewLineItemVO[];
}

export interface DrawerMenuOpenSliceState {
  openMenu: OverlayMenuType;
  /** Set when `openMenu === "vendorOrderItems"` */
  vendorOrderItems: VendorOrderItemsMenuPayload | null;
}

const initialState: DrawerMenuOpenSliceState = {
  openMenu: "none",
  vendorOrderItems: null,
};

export const drawerMenuOpenSlice = createSlice({
  name: "drawerMenuOpenSlice",
  initialState,
  reducers: {
    setOpenMenu: (state, action: PayloadAction<SetOpenMenuPayload>) => {
      state.openMenu = action.payload;
      state.vendorOrderItems = null;
    },
    openVendorOrderItemsMenu: (state, action: PayloadAction<VendorOrderItemsMenuPayload>) => {
      state.openMenu = "vendorOrderItems";
      state.vendorOrderItems = action.payload;
    },
  },
});

export const { setOpenMenu, openVendorOrderItemsMenu } = drawerMenuOpenSlice.actions;
export default drawerMenuOpenSlice;
